import { render, staticRenderFns } from "./NewPaymentsPayoneerFilter.vue?vue&type=template&id=b1511470&scoped=true"
import script from "./NewPaymentsPayoneerFilter.vue?vue&type=script&lang=js"
export * from "./NewPaymentsPayoneerFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1511470",
  null
  
)

export default component.exports